<div *ngIf="fieldsLoaded && !errorToken" class="request-connection">

  <!-- Header card: logo + org name + Connection Name / Benefit / Available to (mirrors web-driver ConnectionCard) -->
  <div class="connection-card">
    <div class="logo-wrap">
      <img *ngIf="logoSrc && !logoError" [src]="logoSrc" alt="" class="connection-logo" (error)="onLogoError()" />
      <div *ngIf="!logoSrc || logoError" class="logo-placeholder" aria-hidden="true">{{ orgInitial }}</div>
    </div>
    <h2 class="org-name" *ngIf="orgName">{{ orgName }}</h2>
    <!-- web-driver's ConnectionCard always renders all three rows (even when a value is empty). -->
    <dl class="connection-details">
      <dt>{{ "Connection Name" | T }}</dt>
      <dd>{{ connectionInfo.connectionName }}</dd>
      <dt>{{ "Benefit" | T }}</dt>
      <dd>{{ connectionInfo.benefit }}</dd>
      <dt>{{ "Available to" | T }}</dt>
      <dd>{{ connectionInfo.availableTo }}</dd>
    </dl>
  </div>

  <form [formGroup]="connectionForm" (ngSubmit)="submitConnection()">
    <!-- Dynamic fields: zero, one, or many, driven entirely by the API (same as web-driver) -->
    <div class="form-group" *ngFor="let field of connectionInfo.connectionFields">
      <label [attr.for]="field.key">{{ field.name }} <span class="required-asterisk">*</span></label>
      <input type="text" class="form-control" data-private="lipsum" [id]="field.key"
        [formControlName]="field.key" [class.invalid]="fieldError(field.key)" />
      <div *ngIf="fieldError(field.key)" class="has-error">{{ "This field is required" | T }}</div>
    </div>

    <!-- Terms & Conditions sentence (implicit consent, like web-driver) -->
    <p class="terms-text" *ngIf="connectionInfo.serviceTcTitle && !companyTermsAvailability"
      (click)="onTermsClick($event)"
      [innerHtml]="'By requesting this connection, you agree to the %name% <a href=\'#\'>Terms and Conditions</a>.' | T: { name: connectionInfo.serviceTcTitle }"></p>

    <p class="terms-text" *ngIf="connectionInfo.serviceTcTitle && companyTermsAvailability"
      (click)="onTermsClick($event)"
      [innerHtml]="'By requesting this connection, you agree to the %name% <a href=\'#\'>Terms and Conditions</a> and %company% <a href=\'#\'>Terms and Conditions</a>.' | T: { name: connectionInfo.serviceTcTitle, company: connectionInfo.companyName || connectionInfo.orgName }"></p>

    <div class="button-container">
      <button type="submit" class="btn btn-lg btn-primary" [disabled]="connectionForm.invalid || isSubmitting">
        {{ "Request Connection" | T }}
      </button>
    </div>
  </form>

  <!-- Failure state: blocked, Retry only -->
  <div *ngIf="requestFailed" class="request-error">
    <p class="has-error">{{ "Failed to request connection. Error: Invalid credentials or network error. Please try again." | T }}</p>
    <button type="button" class="btn btn-outline-primary" (click)="submitConnection()" [disabled]="isSubmitting">
      {{ "Retry Request" | T }}
    </button>
  </div>
</div>

<div *ngIf="errorToken" class="has-error">
  {{ "An error has occurred, please contact your company’s administrator" | T }}
</div>

<cp-terms-dialog [content]="termsText" *ngIf="showTermsModal" [openModal]="showTermsModal"></cp-terms-dialog>
<cp-loader *ngIf="isSubmitting"></cp-loader>
